import { useRef as x, useCallback as P, useMemo as ee, useEffect as K, useState as te } from "react";
import { defaultPhoneConfig as oe, MASK_CHAR as ne } from "../constants/phone-config.mjs";
import { useHistoryState as se } from "./use-history-state.mjs";
import { addDialCode as R } from "../utils/phone-utils/add-dial-code.mjs";
import { getCursorPosition as re } from "../utils/phone-utils/get-cursor-position.mjs";
import { formatPhone as ue } from "../utils/phone-utils/format-phone.mjs";
import { removeNonDigits as w } from "../utils/common/remove-non-digits.mjs";
import { getCountry as E } from "../utils/country-utils/get-country.mjs";
import { guessCountryByPartialNumber as W } from "../utils/country-utils/guess-country-by-partial-number.mjs";
import { parseCountry as _ } from "../utils/country-utils/parse-country.mjs";
const ie = ne, n = oe, ge = ({
  defaultCountry: u = n.defaultCountry,
  initialCountry: k = n.initialCountry,
  value: B = n.value,
  countries: d = n.countries,
  prefix: l = n.prefix,
  defaultMask: O = n.defaultMask,
  allowMoreDigitsThanMaskAllows: j = n.allowMoreDigitsThanMaskAllows,
  charAfterDialCode: g = n.charAfterDialCode,
  historySaveDebounceMS: q = n.historySaveDebounceMS,
  disableCountryGuess: J = n.disableCountryGuess,
  disableDialCodePrefill: Q = n.disableDialCodePrefill,
  forceDialCode: M = n.forceDialCode,
  disableDialCodeAndPrefix: I = n.disableDialCodeAndPrefix,
  dontShowDialCodePrefillOnFocus: L = n.dontShowDialCodePrefillOnFocus,
  onChange: S
}) => {
  const C = B || "", V = I ? !1 : !J, a = x(null), D = ({
    value: e,
    country: t,
    trimNonDigitsEnd: o,
    insertDialCodeOnEmpty: s,
    forceDisableCountryGuess: c
  }) => {
    const v = !c && V ? W({
      phone: e,
      countries: d,
      currentCountryIso2: t.iso2,
      defaultCountry: u
    }) : void 0, h = (v == null ? void 0 : v.country) ?? t;
    return { phone: h ? ue(e, {
      prefix: l,
      mask: h.format || O,
      maskChar: ie,
      dialCode: h.dialCode,
      allowMoreDigitsThanMaskAllows: j,
      trimNonDigitsEnd: o,
      charAfterDialCode: g,
      forceDialCode: M,
      insertDialCodeOnEmpty: s,
      disableDialCodeAndPrefix: I
    }) : e, countryGuessResult: v, formatCountry: h };
  }, G = (e) => {
    typeof document < "u" && document.activeElement === a.current && Promise.resolve().then(() => {
      var t;
      (t = a.current) == null || t.setSelectionRange(e, e);
    });
  }, f = P(
    ({ phone: e, country: t }) => S == null ? void 0 : S({
      phone: e,
      unformatedPhone: w(e),
      country: t,
      prefix: l
    }),
    [S, l]
  ), [{ phone: i, country: y }, b, H, $] = se(
    () => {
      const t = W({
        phone: C,
        countries: d,
        currentCountryIso2: k,
        defaultCountry: u
      }).country || E({
        value: k,
        field: "iso2",
        countries: d,
        defaultCountry: u
      });
      t || console.error(
        `[react-international-phone]: can not find a country with "${u}" iso2 code`
      );
      const o = t || // set "us" if user provided not valid country
      _(d.find((c) => _(c).iso2 === u)), s = D({
        value: C,
        country: o,
        insertDialCodeOnEmpty: L ? !Q : !1
      }).phone;
      return G(s.length), {
        phone: s,
        country: o.iso2
      };
    },
    {
      overrideLastItemDebounceMS: q,
      onChange: f
    }
  ), r = ee(() => E({
    value: y,
    field: "iso2",
    countries: d,
    defaultCountry: u
  }), [d, y, u]), U = P(() => {
    var e;
    L || (e = a == null ? void 0 : a.current) != null && e.value || f == null || f({
      phone: R({
        phone: i,
        dialCode: r.dialCode,
        charAfterDialCode: g,
        prefix: l
      }),
      country: y
    });
  }, [
    g,
    y,
    r,
    f,
    i,
    l,
    L
  ]), z = (e, {
    deletion: t,
    cursorPosition: o,
    insertDialCodeOnEmpty: s,
    inserted: c
  } = {}) => {
    var N;
    let m = e, v = o;
    M && !I && r && // dial code has been changed
    !w(e).startsWith(r.dialCode) && e && (c && e.startsWith(l) && // cursor position was set to 0 before the input
    e.length - (o ?? 0) === 0 ? m = e : (m = i, v = 0));
    const { phone: h, countryGuessResult: p } = D({
      value: m,
      country: r,
      trimNonDigitsEnd: t === "backward",
      // trim values if user deleting chars (delete mask's whitespace and brackets)
      insertDialCodeOnEmpty: s,
      forceDisableCountryGuess: M && !!t && w(m).length < r.dialCode.length
    });
    let A = r;
    V && (p != null && p.country) && p.country.name !== y && p.fullDialCodeMatch && (A = p.country);
    const T = re({
      cursorPositionAfterInput: v ?? 0,
      phoneBeforeInput: i,
      phoneAfterInput: e,
      phoneAfterFormatted: h,
      leftOffset: M ? l.length + (((N = r == null ? void 0 : r.dialCode) == null ? void 0 : N.length) ?? 0) + g.length : 0,
      deletion: t
    });
    return b({
      phone: h,
      country: A.iso2
    }), G(T), h;
  };
  K(() => {
    const e = a.current;
    if (!e) return;
    const t = (o) => {
      if (!o.key) return;
      const s = o.ctrlKey, c = o.shiftKey, m = o.key.toLowerCase() === "z";
      !s || !m || (c ? $() : H());
    };
    return e.addEventListener("keydown", t), () => {
      e.removeEventListener("keydown", t);
    };
  }, [a, H, $]);
  const X = (e) => {
    e.preventDefault();
    const t = e.nativeEvent.inputType, o = () => {
      if ((t == null ? void 0 : t.toLocaleLowerCase().includes("delete")) ?? !1)
        return t != null && t.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
    }, s = t == null ? void 0 : t.startsWith("insertFrom"), c = z(e.target.value, {
      deletion: o(),
      inserted: s,
      cursorPosition: e.target.selectionStart ?? 0
    });
    return I && r ? R({
      phone: c,
      dialCode: r.dialCode,
      charAfterDialCode: g,
      prefix: l
    }) : c;
  }, Y = (e) => {
    const t = E({
      value: e,
      field: "iso2",
      countries: d,
      defaultCountry: u
    });
    if (!t) return;
    const o = I ? "" : `${l}${t.dialCode}${g}`;
    b({
      phone: o,
      country: t.iso2
    }), Promise.resolve().then(() => {
      var s;
      (s = a.current) == null || s.focus();
    });
  }, [Z, F] = te(!1);
  return K(() => {
    if (!Z) {
      F(!0), C !== i && (f == null || f({ phone: i, country: y }));
      return;
    }
    w(C) !== w(i) && z(w(C));
  }, [C]), K(() => {
    if (!i && k) {
      const e = E({
        value: k,
        field: "iso2",
        countries: d,
        defaultCountry: u
      });
      b({
        phone: i,
        country: (e == null ? void 0 : e.iso2) || u
      });
    }
  }, [k]), {
    phone: i,
    // Formatted phone string.
    country: y,
    // Current country iso code.
    setCountry: Y,
    // Country setter.
    handlePhoneValueChange: X,
    // Change handler for input component
    onFocus: U,
    inputRef: a
    // Ref object for input component (handles caret position, focus and undo/redo).
  };
};
export {
  ie as MASK_CHAR,
  n as defaultConfig,
  ge as usePhoneInput
};
